export default class Header {
  constructor() {
    this.elements = {
      target: document.querySelector('.js-header'),
      offcanvas: document.querySelector('.js-offcanvas'),
      offcanvasTrigger: document.querySelector('.js-toggle-offcanvas'),
      searchbarTriggers: document.querySelectorAll('.js-search-trigger'),
      searchbar: document.querySelector('.js-searchbar'),
    };

    this.mainNavigationToggleItems = document.querySelectorAll('.js-navigation-main li.has--children');

    this.siteWrapper = document.querySelector('.js-site-wrapper');

    this.settings = {
      delta: 5,
      trigger: 100,
      offcanvasState: false,
      searchbarState: false,
    };

    this.lastScrollTop = 0;
    this.isDocumentReady = false;

    // Bind this to functions
    this.toggleOffcanvas = this.toggleOffcanvas.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.toggleSearchbar = this.toggleSearchbar.bind(this);

    if (this.elements.target) {
      this.targetHeight = this.elements.target.offsetHeight;

      this._setDOMReferences();
    }
  }

  _setDOMReferences() {
    if (this.elements.offcanvas && this.elements.offcanvasTrigger) {
      this.elements.offcanvasTrigger.addEventListener(
        'click',
        this.toggleOffcanvas
      );
    }

    if (this.elements.searchbar && this.elements.searchbarTriggers.length) {
      for (let i = 0; i < this.elements.searchbarTriggers.length; i++) {
        const element = this.elements.searchbarTriggers[i];
        element.addEventListener('click', this.toggleSearchbar);
      }
    }

    if (this.mainNavigationToggleItems.length) {
      for (let i = 0; i < this.mainNavigationToggleItems.length; i++) {
        const element = this.mainNavigationToggleItems[i];
        const toggle = element.querySelector('.js-toggle-children');
        const children = element.querySelector('.js-children');

        if (toggle && children) {
          toggle.addEventListener('click', () => this.toggleChildren(element, children))
        }
      }
    }

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
  }

  toggleChildren(element, children) {
    if (children.classList.contains('is--visible')) {
      element.classList.remove('children--visible');
      children.classList.remove('is--visible');
    } else {
      element.classList.add('children--visible');
      children.classList.add('is--visible');
    }
  }

  toggleSearchbar() {
    this.settings.searchbarState
      ? (this.settings.searchbarState = false)
      : (this.settings.searchbarState = true);

    const input = this.elements.searchbar.querySelector(
      'input[type=search]'
    );

    if (this.settings.searchbarState) {
      this.elements.searchbar.classList.add('is--visible');
      input.focus();

      if (this.siteWrapper) {
        this.siteWrapper.classList.add('header--open');
      }
    } else {
      this.elements.searchbar.classList.remove('is--visible');
      input.blur();
      if (this.siteWrapper) {
        this.siteWrapper.classList.remove('header--open');
      }
    }
  }

  toggleOffcanvas() {
    this.settings.offcanvasState
      ? (this.settings.offcanvasState = false)
      : (this.settings.offcanvasState = true);
    if (this.settings.offcanvasState) {
      this.elements.offcanvasTrigger.classList.add('is--open');
      this.elements.offcanvas.classList.add('is--visible');
      if (this.siteWrapper) {
        this.siteWrapper.classList.add('header--open');
      }
    } else {
      this.elements.offcanvasTrigger.classList.remove('is--open');
      this.elements.offcanvas.classList.remove('is--visible');
      if (this.siteWrapper) {
        this.siteWrapper.classList.remove('header--open');
      }
    }
  }

  onScroll() {
    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(st - this.lastScrollTop) <= this.settings.delta) {
      return;
    }

    // Check small header
    if (st < this.settings.trigger) {
      this.elements.target.classList.remove('header--small');
    } else {
      this.elements.target.classList.add('header--small');
    }

    if (st > this.lastScrollTop) {
      // scroll down
      if (
        !this.settings.offcanvasState &&
        document.readyState == 'complete' &&
        st > this.settings.trigger
      ) {
        this.elements.target.classList.add('header--up');
      }
    } else {
      // scroll up
      this.elements.target.classList.remove('header--up');
    }

    this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }
}
